import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/components/Header.css';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    // Handle scroll
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const menuItems = [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/about-us' },
        { name: 'Resource Library', path: '/tools' },
        { name: 'Get Involved', path: '/get-involved' },
        { name: "What's Next", path: '/whats-next' },
        { name: 'Blog', path: '/blog' },
        { name: 'Opportunities ', path: '/careers' }
    ];

    return (
        <>
            {/* DESKTOP HEADER */}
            <header className={`header-main header-desktop ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
                <div className="container-fluid px-4 px-lg-5">
                    <div className="d-flex justify-content-between align-items-center py-4">
                        <Link to="/" className="logo" onClick={closeMenu}>
                            <img
                                src="/assets/images/logo.svg"
                                alt="Logo"
                                width={180}
                                height={60}
                            />
                        </Link>


                        <div className="header-right">
                            <nav className={`menu-items ${menuOpen ? 'visible' : ''}`}>
                                {menuItems.map((item, index) => (
                                    <Link
                                        key={index}
                                        to={item.path}
                                        className={`menu-item ${location.pathname === item.path ? 'active' : ''
                                            } ${hoveredItem === index ? 'hovered' : ''}`}
                                        onMouseEnter={() => setHoveredItem(index)}
                                        onMouseLeave={() => setHoveredItem(null)}
                                        onClick={closeMenu}
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                            </nav>

                            <button
                                className={`menu-toggle ${menuOpen ? 'open' : ''}`}
                                onClick={toggleMenu}
                                aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                            >
                                {!menuOpen ? (
                                    <svg width="30" height="40" viewBox="0 0 30 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="7.99999" width="30" height="4" rx="2" fill="#191E35" />
                                        <rect y="18" width="30" height="4" rx="2" fill="#191E35" />
                                        <rect x="15" y="28" width="15" height="4" rx="2" fill="#191E35" />
                                    </svg>
                                ) : (
                                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M23 7L7 23M7 7L23 23" stroke="#006EFD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* MOBILE HEADER */}
            <header className={`header-main header-mobile ${menuOpen ? 'menu-active' : ''} ${scrolled ? 'scrolled' : ''}`}>
                <div className="container-fluid px-3">
                    <div className="d-flex justify-content-between align-items-center py-2">
                        <Link to="/" className="logo-mobile" onClick={closeMenu}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="60" viewBox="0 0 65 75" fill="none">
                                <path d="M5.02684 38.8821C7.45261 31.3409 26.8461 29.6064 44.2538 34.7847C45.1713 35.0612 46.0637 35.3503 46.931 35.6519C43.5123 33.9426 39.6662 32.3966 35.5186 31.1523C18.4 26.0117 2.61364 27.7336 0.288429 34.9984C-0.930737 38.8067 1.78411 43.3943 7.12582 47.6299C4.97657 44.5632 4.19731 41.4964 5.02684 38.8821Z" fill="#191E35" />
                                <path d="M57.074 43.4826C57.074 43.4826 57.0363 43.4826 57.0237 43.4701C59.9899 46.5117 61.3599 49.5408 60.5304 52.0922C60.1408 53.2737 59.2987 54.2415 58.0795 55.0207C58.0166 55.0584 57.9664 55.0961 57.9035 55.1339C57.7778 55.2093 57.6647 55.2847 57.5265 55.3475C56.7472 55.7749 55.8297 56.1519 54.8116 56.4536C54.3717 56.5918 53.9318 56.7426 53.4919 56.8809C45.2217 59.1056 34.4503 57.7104 25.2374 55.1967C24.5713 55.0584 23.9177 54.9076 23.2516 54.7442C21.1023 54.2415 19.041 53.6507 17.0803 52.9972C17.1055 53.0349 17.1306 53.0726 17.1683 53.0852C19.3553 54.3169 21.6428 55.4229 23.9931 56.4033C31.107 59.3695 38.6859 61.3931 46.4911 61.7701C50.5131 61.921 54.8745 61.9712 58.7456 60.3122C67.9962 56.1142 64.9797 47.0396 57.0866 43.4701L57.074 43.4826Z" fill="#191E35" />
                                <path d="M24.6843 68.758C15.0064 65.1759 10.6073 53.0094 12.5555 38.1658C8.16899 55.8374 11.9773 71.5986 21.8438 74.5271C28.2412 76.425 35.7448 72.4909 42.1171 64.8743C36.1093 69.022 29.7872 70.6559 24.6843 68.758Z" fill="#191E35" />
                                <path d="M44.8444 0.484767C35.1665 -2.45631 22.9748 8.26481 16.0117 25.0566C23.1256 13.0158 32.9921 6.06528 41.1492 8.55389C52.0462 11.872 55.7289 30.788 49.3691 50.7974C49.168 51.4384 48.9543 52.0668 48.7407 52.6952C50.2866 49.5908 51.6692 46.2349 52.8004 42.6528C59.1476 22.6309 55.5906 3.75263 44.857 0.484767H44.8444Z" fill="#191E35" />
                            </svg>
                        </Link>

                        <button
                            className={`menu-toggle-mobile ${menuOpen ? 'open' : ''}`}
                            onClick={toggleMenu}
                            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                        >
                            {!menuOpen ? (
                                <svg width="30" height="40" viewBox="0 0 30 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="7.99999" width="30" height="4" rx="2" fill="#191E35" />
                                    <rect y="18" width="30" height="4" rx="2" fill="#191E35" />
                                    <rect x="15" y="28" width="15" height="4" rx="2" fill="#191E35" />
                                </svg>
                            ) : (
                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M23 7L7 23M7 7L23 23" stroke="#006EFD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            )}
                        </button>
                    </div>
                </div>

                {/* Mobile Sidebar */}
                <div className={`mobile-sidebar ${menuOpen ? 'active' : ''}`}>
                    <nav className="mobile-menu-items">
                        {menuItems.map((item, index) => (
                            <Link
                                key={index}
                                to={item.path}
                                className={`mobile-menu-item ${location.pathname === item.path ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                {item.name}
                            </Link>
                        ))}
                    </nav>
                </div>
            </header>

            {/* Mobile Menu Backdrop */}
            {menuOpen && (
                <div className="mobile-menu-backdrop" onClick={closeMenu}></div>
            )}
        </>
    );
};

export default Header;